import { configureStore, isRejectedWithValue, Middleware } from '@reduxjs/toolkit'
import { createStandaloneToast } from "@chakra-ui/react"
import { subscriptionSlice } from 'domains/subscription';
import { teamSlice } from 'domains/team';
import { accountSlice } from 'domains/account';
import { creatorCardSlice } from 'domains/creator-card';

export const errorLogger: Middleware = () => (next) => (action) => {
  const toast = createStandaloneToast();

  if (isRejectedWithValue(action) && action.payload !== 'UNAUTHORIZED') {
    toast({
      position: 'top-right',
      duration: 5000,
      isClosable: true,
      title: 'An error occurred',
      description: action.payload || 'Please try again',
      status: "error",
    })
  }

  return next(action);
}

export const makeStore = () => {
  return configureStore({
    reducer: { 
      account: accountSlice.reducer,
      subscription: subscriptionSlice.reducer,
      team: teamSlice.reducer,
      creatorCard: creatorCardSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(errorLogger),
  })
};

const store = makeStore();

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
